import { cn } from '@/lib/utils'
import { getPluginSlots } from '@/plugin/slots'

/** Tenants with a branded decorative layer behind shells. */
export function tenantHasClientBackgroundDecor(): boolean {
  return getPluginSlots().hasBackgroundDecor
}

/**
 * Shell decor can wash out the cinematic hero; tenants with a hero image use the image only.
 */
export function shouldRenderGuestMarketingShellBackground(): boolean {
  return getPluginSlots().guestMarketingShellBackground
}

export function getGuestSurfaceBackgroundClassName(extra?: string): string {
  const base = 'pointer-events-none absolute inset-0 z-0 h-full w-full'
  const fromPlugin = getPluginSlots().guestBackgroundClassName
  if (fromPlugin) {
    return cn(base, fromPlugin, extra)
  }
  return cn(base, 'opacity-75 dark:hidden', extra)
}

export function ClientBackground({
  className = '',
  variant,
}: {
  className?: string
  variant?: 'default' | 'auth'
}) {
  const Background = getPluginSlots().background
  if (!Background) return null
  return <Background className={className} variant={variant} />
}
